import React, { Component } from 'react';
/* import algoliasearch from 'algoliasearch/lite'; */
import 'react-accessible-accordion/dist/fancy-example.css';
/* import orderBy from 'lodash.orderby'; */
import qs from 'qs';
import PropTypes from 'prop-types';
import '../css/search.css';
/* import SEO from "../components/seo"
import Media from 'react-media'; */
import AlgoliaHits from "../components/AlgoliaHits"
import {
  Hits,
} from 'react-instantsearch-dom';
/* import { matchRoutes, renderRoutes } from "react-router-config"; */


const DEBOUNCE_TIME = 700;

const createURL = state => `?${qs.stringify(state)}`;

const searchStateToUrl = (props, searchState) =>
searchState ? `${props.location.pathname}${createURL(searchState)}` : '';

/* console.log("searchStateToUrl", searchStateToUrl) */

const urlToSearchState = location => qs.parse(location.search.slice(1));

/* console.log("urlToSearchState", urlToSearchState) */


class AlgoliaInstantSearchCreateURLRefinementLists extends Component {


  state = {
    searchState: urlToSearchState(this.props.location),
    lastLocation: this.props.location,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.location !== state.lastLocation) {
      return {
        searchState: urlToSearchState(props.location),
        lastLocation: props.location,
      };
    }

    return null;
  }

  onSearchStateChange = searchState => {
    clearTimeout(this.debouncedSetState);

    this.debouncedSetState = setTimeout(() => {
/*       this.props.history.push(
        searchStateToUrl(this.props, searchState),
        searchState
      ); */
      searchStateToUrl(this.props, searchState)
    }, DEBOUNCE_TIME);

    this.setState({ searchState });
    /* console.log("searchState", searchState) */
  };

  render() {
    return (
      <Hits hitComponent={AlgoliaHits} />
    );
  }
}


AlgoliaHits.propTypes = {
  hit: PropTypes.object.isRequired,
};

AlgoliaInstantSearchCreateURLRefinementLists.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.object.isRequired,
};

export default AlgoliaInstantSearchCreateURLRefinementLists;